import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';
import { UserRolesEnum } from 'src/app/common/enums/user-roles-enum';
import { UserManageService } from 'src/app/services/user-manage.service';

@Component({
    selector: 'app-reset-user-password-dialog',
    templateUrl: './reset-user-password-dialog.component.html',
    styleUrls: ['./reset-user-password-dialog.component.css'],
    standalone: false
})
export class ResetUserPasswordDialogComponent {

  currentUser=this.userManageService.currentUser
  currentClinic=this.userManageService.currentClinic
  currentOffice=this.userManageService.currentOffice

  UserRolesEnum=UserRolesEnum

  constructor(private dialogRef: MatDialogRef<any>,private userManageService:UserManageService) { }

  ngOnInit(): void {
    this.dialogRef.afterClosed().pipe(take(1)).subscribe(() =>
      {
        
          this.userManageService.clearUser()
        
      })
  }


  exit()
  {
    this.userManageService.clearUser()
    this.dialogRef.close(`Excellent`);
  }

  onSubmit()
  {

    this.userManageService.resetUserPassword()
    this.dialogRef.close(`Excellent`);
    
  }
}


